import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function CursorTouch({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M5.20996 8H6.20996M17.21 8H16.21M15.45 3.76L14.74 4.46M6.95996 3.76L7.66996 4.46M11.21 2V3M12.706 13V8.5C12.706 7.67 12.026 7 11.206 7C10.376 7 9.70596 7.67 9.70596 8.5V16L7.66596 15.32C7.07296 15.12 6.41596 15.27 5.97596 15.71C5.28596 16.39 5.33596 17.524 6.08596 18.146L10.136 21.516C10.496 21.806 10.946 21.976 11.416 21.976H15.926C16.926 21.976 17.785 21.216 17.906 20.216L18.446 15.873C18.576 14.803 17.846 13.823 16.786 13.652L12.676 12.962L12.706 13Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default CursorTouch;